import { useEffect } from "react";
import Breadcrumb from "../components/Breadcrumb";
import HeaderOne from "../components/HeaderOne";
import { useLoader } from "../context/LoaderContext";
import Animation from "../helper/Animation";
import Preloader from "../helper/Preloader";
import { fetchCompanyDetails } from "../api/CompanyDetailsApi";
import FooterThree from "../components/FooterThree";
import { useAllDataContext } from "../context/AllDataContext";
import { FetchAllApi } from "../components/FetchAllApi";
import { useLocation } from "react-router-dom";
import { useCompanyDetailsContext } from "../context/CompanyDetailsContext";
import ChairmenMessage from "../components/ChairmenMessage";

const ManagementTeamPage = () => {
  const { setLoading } = useLoader();
  const { companyDetailsData, setCompanyDetailsData } =
    useCompanyDetailsContext();
  // const [contactHeaderData, setContactHeaderData] = useState([]);
  // const [contactFormHeaderData, setContactFormHeaderData] = useState([]);
  const { allData, setAllData } = useAllDataContext();
  const location = useLocation();

  useEffect(() => {
    const section = location.state?.section;
    if (section) {
      const el = document.getElementById(section.toLowerCase());
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  }, [location.state]);

  FetchAllApi({ companyDetailsData, setAllData, setLoading });

  useEffect(() => {
    if (companyDetailsData.length === 0) {
      Promise.all([fetchCompanyDetails()])
        .then(([companyDetailsData]) => {
          setCompanyDetailsData(companyDetailsData);
        })
        .catch(() => {
          console.error("Server Error");
        });
    }
  }, [companyDetailsData.length, setCompanyDetailsData]);

  return (
    <div>
      {/* Preloader */}
      <Preloader />

      {/* Animation */}
      <Animation />

      {/* HeaderTwo */}
      <HeaderOne />

      {/* Breadcrumb */}
      <Breadcrumb
        heading={"Management Core Team"}
        title={"Management Core Team"}
      />

      <div className="container py-80">
        <img
          src={`${process.env.REACT_APP_cmsUrl}${allData.managementTeamImageData[0]?.image[0]?.media?.url}`}
          alt="Management Team"
          className="img-fluid"
        />
      </div>

      {allData.managementTeamMessageData.map((item, index) => (
        <ChairmenMessage
          key={index}
          chairmanData={[item]}
          reverse={index % 2 !== 0}
        />
      ))}

      {/* FooterOne */}
      <FooterThree />
    </div>
  );
};

export default ManagementTeamPage;
